module.exports = __webpack_public_path__ + "img/android5bg2.98662a82.png";